export default "__VITE_ASSET__DhOlVMkf__"